<template src="./templates/Categories.html" />

<script setup>

import {
    useCategoriesStore,
} from '@timezoneone/dottie-client-jam';

import TopLevelCategories from './TopLevelCategories.vue';

import { showMore } from '../utils/showMore';

const categoriesStore = useCategoriesStore();

</script>
